<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ftit"><a id="page_viii"></a>Kings of England in the<br/>Later Middle Ages</h2>
<p class="noindent">Henry III, reigned 1216 to 1272; son of King John and Isabelle of Angoulême; married Eleanor of Provence in 1236</p>
<p class="noindent1">Edward I, r. 1272 to 1307; son of Henry and Eleanor; married Leonor of Castile in 1254 and Marguerite of France in 1299</p>
<p class="noindent1">Edward II, r. 1307 to 1327; son of Edward and Leonor; married Isabella of France in 1308</p>
<p class="noindent1">Edward III, r. 1327 to 1377; son of Edward and Isabella; married Philippa of Hainault in 1328</p>
<p class="noindent1">Richard II, r. 1377 to 1399; son of Edward and Philippa’s eldest son the Prince of Wales; married Anne of Bohemia in 1382 and Isabelle de Valois in 1396; childless</p>
<p class="noindent1">Henry IV, r. 1399 to 1413; son of Edward III and Philippa’s son the Duke of Lancaster; married Mary de Bohun in 1394 and Juana of Navarre in 1403</p>
<p class="noindent1">Henry V, r. 1413 to 1422; son of Henry and Mary; married Katherine de Valois in 1420</p>
<p class="noindent1">Henry VI, r. 1422 to 1461 and 1470 to 1471; son of Henry and Katherine; married Marguerite of Anjou in 1445</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Kings_of_England.vue?3b1b89f2